// A place for visual flourish components
import { Wave } from './Wave'
import { CurlyDivider } from './CurlyDivider'

// Exporting this way since the export in index.tsx, "export * as Blocks from "./components/Blocks" triggers an error on parcel
// exactly this issue: https://github.com/parcel-bundler/parcel/issues/5911
// export all blcoks as Blocks to be able to use sth like: <Blocks.Wave>
// by using your IDE, you will have an autocomplete like Blocks.<all_available_icons>
export const Blocks = { Wave, CurlyDivider }
